module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Welcome to Our Site")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1252b34f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lesson2/components/Header.vue
// module id = 24
// module chunks = 0